var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOmegaGrey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 2,
    fill: "#E6E5E4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.95161 6.09677C4.95161 4.50251 6.63352 2.95161 9.06452 2.95161C11.4955 2.95161 13.1774 4.50251 13.1774 6.09677C13.1774 7.52694 11.8239 8.92222 9.79032 9.19429V8.03226C9.79032 7.63141 9.46537 7.30645 9.06452 7.30645C8.66366 7.30645 8.33871 7.63141 8.33871 8.03226V9.19429C6.30511 8.92222 4.95161 7.52694 4.95161 6.09677ZM8.33871 10.6538C5.72502 10.3671 3.5 8.55348 3.5 6.09677C3.5 3.41528 6.15083 1.5 9.06452 1.5C11.9782 1.5 14.629 3.41528 14.629 6.09677C14.629 8.55348 12.404 10.3671 9.79032 10.6538V15.7742C9.79032 16.175 9.46537 16.5 9.06452 16.5C8.66366 16.5 8.33871 16.175 8.33871 15.7742V10.6538Z",
    fill: "#4A4540"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOmegaGrey);
export default __webpack_public_path__ + "static/media/omega-grey.4587d4b7abfbd439a489350aa29c6042.svg";
export { ForwardRef as ReactComponent };